export interface ContributionValues {
  contributionType?: string
  contributionYear?: string
}

export const PREVIOUS = 'PREVIOUS'
export const CURRENT = 'CURRENT'
